import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Tooltip,
  CircularProgress,
  Box,
  styled,
  Menu,
  MenuItem,
} from "@mui/material";
import FavoriteIcon from "../../assets/images/FavoriteIcon.png";
import FavoriteBorderIcon from "../../assets/images/FavoriteBorderIcon.png";
import { getNameInitials, getColor, getContrastColor } from "../../utils/common";
import PropTypes from "prop-types";

const StyledHeadCell = styled(TableCell)(() => ({
  fontWeight: "bold"
}));

const BoardTable = ({
  boards,
  searchValue,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onBoardClick,
  onFavoriteClick,
  loadingFav,
  favId,
  handleRightClick,
  rightClickState,
  cloneBoard,
  handleRightClickClose,
  handleOpenCloneBoard,
}) => {
  const headCells = ['ID', 'Board Name', 'Favorite'];
  const filteredBoards = boards.filter(
    (item1) =>
      item1.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      item1.id.toString() === searchValue.toString()
  );
  const favoriteTableCell = (board) => {
    if (loadingFav && favId === board.id) {
      return (<CircularProgress size={16} />)
    } else if (board.favorite || board.isfavorite) {
      return (
        <Tooltip title="Favorite board" placement="right">
          <Box
            component="img"
            src={FavoriteIcon}
            alt=""
            style={{ cursor: "pointer", width: 20, height: 20 }}
            onClick={(e) => onFavoriteClick(board.id, e)}
          />
        </Tooltip>
      )
    } else {
      return (
        <Tooltip title="Click to make favorite" placement="right">
          <Box
            component="img"
            src={FavoriteBorderIcon}
            alt=""
            style={{ cursor: "pointer", width: 20, height: 20 }}
            onClick={(e) => onFavoriteClick(board.id, e)}
          />
        </Tooltip>
      )
    }
  }

  return (
    <Box component={'div'}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {
                headCells.map((headCell) => (
                  <StyledHeadCell key={headCell}>{headCell}</StyledHeadCell>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              filteredBoards.length ?
                filteredBoards
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((board) => (
                    <TableRow
                      key={board.id}
                      hover
                      onClick={() => onBoardClick(board)}
                      style={{ cursor: "pointer" }}
                      onContextMenu={(e) => handleRightClick(e, board)}
                    >
                      <TableCell>{board.id}</TableCell>
                      <TableCell>
                        <Box component={'div'} style={{ display: "flex", alignItems: "center" }}>
                          <Box
                            component={'div'}
                            className="board-initials"
                            style={{
                              background: board.settings.color
                                ? board.settings.color
                                : getColor(board.name),
                              color: board.settings.color
                                ? getContrastColor(board.settings.color)
                                : getContrastColor(getColor(board.name)),
                              marginRight: 10,
                              width: 30,
                              height: 30,
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "12px",
                            }}
                          >
                            {board.settings.initials
                              ? board.settings.initials
                              : getNameInitials(board.name)}
                          </Box>
                          {board.name}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {favoriteTableCell(board)}
                      </TableCell>
                    </TableRow>
                  )) :
                <TableRow>
                  <TableCell colSpan={headCells?.length} align="center">
                    No Data Found!
                  </TableCell>
                </TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        sx={{
          '& .MuiTablePagination-toolbar': {
            justifyContent: 'space-between',
            alignItems: 'center'
          },
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
            margin: 0
          }
        }}
        count={filteredBoards.length}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />

      {cloneBoard && (
        <Menu
          keepMounted
          open={rightClickState.mouseY !== null}
          onClose={handleRightClickClose}
          anchorReference="anchorPosition"
          anchorPosition={
            rightClickState.mouseY !== null && rightClickState.mouseX !== null
              ? { top: rightClickState.mouseY, left: rightClickState.mouseX }
              : undefined
          }
        >
          <MenuItem onClick={() => handleOpenCloneBoard(cloneBoard)}>
            Clone Board
          </MenuItem>
        </Menu>
      )}

    </Box>
  );
};

BoardTable.propTypes = {
  boards: PropTypes.array.isRequired,
  searchValue: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  onBoardClick: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  loadingFav: PropTypes.bool.isRequired,
  favId: PropTypes.string,
  handleRightClick: PropTypes.func.isRequired,
  rightClickState: PropTypes.object.isRequired,
  cloneBoard: PropTypes.object,
  handleRightClickClose: PropTypes.func.isRequired,
  handleOpenCloneBoard: PropTypes.func.isRequired
};

export default BoardTable;